import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from '@app/app.constants';
import { DeviceSpecification } from '@app/core/interfaces/c5/device-specification';
import { wrapError } from '@app/utils/rxjs';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DeviceSpecificationsRepository {
  constructor(private http: HttpClient) {}

  list(phoneType?: string): Observable<DeviceSpecification[]> {
    const params: any = {};

    if (phoneType !== undefined) {
      params.deviceSpecType = phoneType;
    }

    return of(apiUrl('/deviceSpecs')).pipe(
      mergeMap((url) =>
        this.http.get<DeviceSpecification[]>(url, {
          params,
        })
      ),
      wrapError('system-repository:list-device-specifications')
    );
  }
}
